import { extend } from 'flarum/common/extend';
import Dropdown from 'flarum/common/components/Dropdown';
const BOXED_LIST_SELECTOR = '.ChampisDiscussionList-header ~ .DiscussionList .DiscussionList-discussions';

// Kept free between a menu and the edge it stops at.
const MARGIN = 8;

/**
 * Opens a dropdown menu downward or upward - whichever it fits - in place
 * of core's own choice (Dropdown.tsx oncreate()), which had two faults on
 * a short window (Fifi, Firefox, discussion page's "Répondre" menu,
 * 2026-10-13):
 *
 * - it measures the menu before taking off the previous opening's
 *   .Dropdown-menu--top, so a menu that doesn't fit below opened upward,
 *   then downward the next time (measured in its upward position, it
 *   "fitted"), and so on, once in two;
 * - upward, it only stops at the top of the page, not at the header: the
 *   blue bar covered the menu's middle items ("Journal d'audit",
 *   "Modifier la catégorie").
 *
 * Here: below if it fits, else above if it fits under the header, else
 * below with the page scrolled to show it - a menu cut short inside its
 * own height (tried first) looked complete, its last items out of sight
 * with nothing to tell. Inside the homepage's bordered discussion "card" (see
 * forum.less), below means within the card: a menu from one of its last
 * rows goes up rather than poking out of the card's border - unless only
 * the viewport has room for it.
 *
 * Runs right after core's listener (extend() calls the original oncreate(),
 * which binds it, first - jQuery runs same-event handlers in binding
 * order), in the same event, so core's placement never gets painted.
 *
 * Not for the header's own menus (fitHeaderMenusToViewport, they always
 * drop down), nor menus that aren't dropping down from their button at all
 * (position other than absolute: the phone's bottom sheets, inline menus).
 */
function place(dropdown) {
  const menu = dropdown.querySelector(':scope > .Dropdown-menu');
  if (!menu || dropdown.closest('#header') || getComputedStyle(menu).position !== 'absolute') return;
  menu.classList.remove('Dropdown-menu--top');
  menu.style.maxHeight = '';
  menu.style.overflowY = '';
  const button = dropdown.getBoundingClientRect();
  const down = menu.getBoundingClientRect();
  const gap = down.top - button.bottom;

  // A modal or the composer lies above the header: only the screen's top
  // edge bounds them.
  const header = dropdown.closest('.Modal, .Composer') ? null : document.getElementById('header');
  const top = Math.max(0, header?.getBoundingClientRect().bottom ?? 0) + MARGIN;
  const screenBottom = window.innerHeight - MARGIN;
  const card = dropdown.closest(BOXED_LIST_SELECTOR);
  const bottom = card ? Math.min(screenBottom, card.getBoundingClientRect().bottom) : screenBottom;
  const below = bottom - button.bottom - gap;
  const above = button.top - gap - top;
  const screenBelow = screenBottom - button.bottom - gap;
  if (down.height <= below) return;
  if (down.height <= above) {
    menu.classList.add('Dropdown-menu--top');
    return;
  }
  if (down.height <= screenBelow) return;

  // Fits neither: below, the page scrolled just enough to show it whole
  // (the discussion page's sidebar is sticky: it rises with the page up to
  // just under the header).
  menu.style.scrollMarginBottom = `${MARGIN}px`;
  menu.scrollIntoView({
    block: 'nearest'
  });

  // Still too tall (a really short window): scrolling inside its own height.
  const room = window.innerHeight - MARGIN - menu.getBoundingClientRect().top;
  if (down.height > room) {
    menu.style.maxHeight = `${room}px`;
    menu.style.overflowY = 'auto';
  }
}
export default function placeDropdownMenus() {
  extend(Dropdown.prototype, 'oncreate', function (value, vnode) {
    const dropdown = vnode.dom;
    $(dropdown).on('shown.bs.dropdown', () => place(dropdown));
  });
}